export default {
  header: {
    title: 'Entries',
    tabs: {
      active: 'Active',
      finalized: 'Final',
      invites: 'Invites',
    },
  },
  filters: {
    sortBy: {
      title: 'Sort by',
      options: {
        nextSlateStarting: 'Next slate starting soonest',
        recentlyEntered: 'Recently entered',
        highestEntryFee: 'Highest entry fee',
        lowestEntryFee: 'Lowest entry fee',
        highestTotalPrizes: 'Highest total prizes',
      },
    },
    league: {
      title: 'Sport',
      options: {
        all: 'All',
        // Rest of the options are dynamically loaded from the backend
      },
    },
    gameType: {
      title: 'Game types',
      options: {
        all: 'All',
        team_survivor: 'Survivor',
        team_pick_em: "Pick'Em",
        player_tier: 'Tiers',
        player_one_and_done: 'One & Done',
        player_survivor: 'Player Survivor',
      },
    },
    status: {
      title: 'Status',
      options: {
        all: 'All',
        missingPicks: 'Missing picks',
        scheduled: 'Not yet started',
        inProgress: 'Started',
      },
    },
    hasEntryFee: {
      title: 'Entry type',
      options: {
        all: 'All',
        entryFee: 'Entry fee',
        noEntryFee: 'No entry fee',
      },
    },
  },
  states: {
    empty: {
      signedOut: {
        title: 'You need to be logged in',
        text: 'Please log in or sign up to view your contests.',
      },
      active: {
        title: 'No Active Contests',
        text: 'Find a contest and get in the game.',
      },
      finalized: {
        title: 'No completed contests yet',
        text: 'Once you finish a contest, it’ll show up here.',
      },
      invites: {
        title: 'No invites right now',
        text: 'You’ll find any contest invites from players or Splash here.',
      },
      buttonText: {
        createContest: 'Create a contest',
        showFinalContests: 'Show final contests',
        showActiveContests: 'Show active contests',
        discoverContests: 'Discover Contests',
        signIn: 'Log In',
        signUp: 'Sign Up',
      },
      discover: {
        text: 'Find a contest and get in the game.',
      },
      filtered: {
        title: 'No contests match your filters',
        text: 'Change or reset the filters to view your contests.',
      },
    },
    error: {
      title: 'Something went wrong',
      subtitle1: 'Our servers could not handle your request.',
      subtitle2: "Don't worry, our development team was already notified. Try refreshing the page.",
      action: 'Reload the page',
    },
  },
  itemsCount: 'Showing {{count}} out of {{total}} contests',
};
